import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: [],
  totalRecords: 0,
  totalPages: 0,
  isLoading: true,
  listError: '',
};

const codReturnOrdersSlice = createSlice({
  name: 'CodReturnOrders',
  initialState,
  reducers: {
    setListLoading(state, action) {
      state.isLoading = action.payload;
    },
    setCodReturnOrders(state, action) {
      const payload = action.payload || {};
      const data = payload.data || {};
      const pagination = payload.pagination || data.pagination || {};
      // Accept the row array wherever the API puts it
      state.list = Array.isArray(data)
        ? data
        : data.data ||
          data.rows ||
          data.orders ||
          data.list ||
          data.codReturnList ||
          data.returnList ||
          [];
      state.totalRecords = Number(
        pagination.total ??
          data.recordsTotal ??
          data.total_records ??
          data.totalRecords ??
          data.total ??
          payload.recordsTotal ??
          0,
      );
      state.totalPages = Number(
        pagination.total_pages ?? pagination.totalPages ?? 0,
      );
      state.isLoading = false;
      state.listError = '';
    },
    setListError(state, action) {
      state.list = [];
      state.totalRecords = 0;
      state.totalPages = 0;
      state.isLoading = false;
      state.listError = action.payload || 'Failed to load COD return orders.';
    },
  },
});

export const { setListLoading, setCodReturnOrders, setListError } =
  codReturnOrdersSlice.actions;

const codReturnOrdersReducer = codReturnOrdersSlice.reducer;

export default codReturnOrdersReducer;
